'use strict';

/**
 * Submit payload check (RPI-1136).
 *
 * `get_next_question` runs this right before the request. A key the page never
 * declared means a widget or script put something in the payload the backend
 * did not ask for, so the key names are reported. Pure: the caller passes
 * `page_state.allvars` and `page_state.vardata` in.
 */

/**
 * Report-only until real traffic shows no false positives: the request is
 * still sent, so a customer script that calls `get_next_question` with its own
 * keys never strands the respondent. `true` blocks the request instead.
 */
export var BLOCK_UNEXPECTED_KEYS = false;

/**
 * Keys the client adds itself. `events.js` adds the first eight (timing, the
 * all/this strings, consent, Facebook, page context) and the navigation
 * markers `__submit__` (Next, Skip) and `__back__`; `get_next_question` adds
 * `__client__` and `__version__` to every request, and on IE
 * `Gryphon.util.IE_do_not_cache` adds the `__ts__` cache-buster.
 */
var SYSTEM_KEYS = [
  '__time__',
  '__page_timing_source__',
  '__debug_timings__',
  '__all__',
  '__this__',
  '__spd_consent_text_shown__',
  '__facebook__',
  '__pg_context__',
  '__submit__',
  '__back__',
  '__client__',
  '__version__',
  '__ts__',
];

/**
 * The payload keys that are not a declared variable, a `vardata` key or a
 * system key, in payload order. Empty when the payload may be sent.
 *
 * @param {Object} data The request payload, read-only.
 * @param {Array<string>} [allvars] `page_state.allvars`.
 * @param {Object} [vardata] `page_state.vardata`.
 * @returns {Array<string>} The unexpected keys.
 */
export function unexpectedPayloadKeys(data, allvars, vardata) {
  var hasOwn = Object.prototype.hasOwnProperty;
  var declared = Array.isArray(allvars) ? allvars : [];
  vardata = vardata || {};
  return Object.keys(data || {}).filter(function (key) {
    return (
      SYSTEM_KEYS.indexOf(key) === -1 &&
      declared.indexOf(key) === -1 &&
      !hasOwn.call(vardata, key)
    );
  });
}
